import { singletonFactory } from '@warehouse/shared/util';
import { AccessTokenGetter, AuthScopesRepository } from '../core';
import { getScopesFromAccessToken } from '../util';

export class AuthScopesRepositoryImpl implements AuthScopesRepository {
	#tokenGetter: AccessTokenGetter | null = null;

	setTokenGetter(tokenGetter: AccessTokenGetter | null): void {
		this.#tokenGetter = tokenGetter;
	}

	async getScopes(): Promise<string[]> {
		if (this.#tokenGetter === null) return [];
		try {
			const token = await this.#tokenGetter();
			return getScopesFromAccessToken(token);
		} catch {
			return [];
		}
	}
}

export const authScopesRepositorySingleton = singletonFactory<AuthScopesRepository>({
	factory: () => new AuthScopesRepositoryImpl(),
});
